import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getAddressObject,
} from '../AddressAutocomplete';
import { LocationIcon } from '../../icons/menu';
import './style.css';

/*
* https://developers.google.com/maps/documentation/javascript/places-autocomplete
https://developers.google.com/maps/documentation/javascript/examples/geocoding-component-restriction
*/
const ERRORS = {
  NO_RESULT: 'NO_RESULT',
  OUT_BOUNDS: 'OUT_BOUNDS',
};
const OUT_BOUNDS_ERROR_MESSAGE = 'Oh no! Looks like you might be out of our delivery area!';
const NO_RESULT_ERROR_MESSAGE = 'Help us confirm your address.';

class AddressAutocompleteContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      geocodeResults: null,
      loading: false,
      noPredictionsError: false,
      error: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.renderGeocodeFailure = this.renderGeocodeFailure.bind(this);
    this.renderGeocodeSuccess = this.renderGeocodeSuccess.bind(this);
  }

  predictionInvalid = (bool, error = null) => {
    this.setState({
      noPredictionsError: bool,
      address: '',
      error,
    });
  }

  proceedWithValidAddress = (address, placeId, originalAddress) => {
    this.setState({
      address,
      loading: true
    });
    geocodeByAddress(address)
      .then((results) => getAddressObject(results).then((addressObj) => {
        addressObj = {...addressObj, placeId};
        this.setState({
          loading: false
        });
        if (!this.verifyAddress(addressObj)) {
          this.predictionInvalid(true);
          console.error(`Address doesn't have building # : ${addressObj.street}`);
        } else {
          this.props.onAddress(addressObj, originalAddress);
        }
      }))
      .catch((error) => {
        console.error('Google Places Geo API error:', error);
        this.setState({
          geocodeResults: this.renderGeocodeFailure(error),
          loading: false
        });
      });
  };

  findFirstAddress = async (address) => {
    try {
      const results = await geocodeByAddress(address);
      const addressObj = await getAddressObject(results);
      return addressObj;
    } catch (error) {
      console.error('Google autocomplete parser error:', error);
      return null;
    }
  };

  handleSelect = async (address, placeId, originalAddress) => {
    if (address === originalAddress) return;

    await this.props.checkIsCorrectDeliveryAddress(placeId).then((res) => {
      if (res) {
        this.predictionInvalid(false);
        this.proceedWithValidAddress(address, placeId, originalAddress);
      } else {
        this.predictionInvalid(true, ERRORS.OUT_BOUNDS);
      }
    });
  }

  handleChange(address) {
    this.setState({
      address,
      geocodeResults: null,
      noPredictionsError: false
    });
    this.props.onChange(address);
  }

  renderGeocodeFailure(err) {
    return (
      <div className="alert alert-danger" role="alert">
        <strong>Error!</strong> {err}
      </div>
    );
  }

  renderGeocodeSuccess(lat, lng) {
    return (
      <div className="alert alert-success" role="alert">
        <strong>Success!</strong> Geocoder found latitude and longitude: <strong>{lat}, {lng}</strong>
      </div>
    );
  }

  renderAddressSuccess(addressObj) {
    return (
      <div className="alert alert-success" role="alert">
        <strong>Success!</strong> Geocoder found latitude and
        longitude: <strong>{addressObj.street}, {addressObj.city}, {addressObj.state}, {addressObj.zip}</strong>
      </div>
    );
  }

  onError = (status) => {
    console.error(`Google Places Error: ${status}`)
    this.setState({
      noPredictionsError: true,
      error: ERRORS.NO_RESULT,
    });
  }

  verifyAddress = address => (
    address.hasOwnProperty('street') &&
      address.street.indexOf('undefined') === -1
  );

  getErrorMessage = () => {
    const { error } = this.state;

    if (error === ERRORS.OUT_BOUNDS) {
      return OUT_BOUNDS_ERROR_MESSAGE;
    }

    return NO_RESULT_ERROR_MESSAGE;
  }

  render() {
    const cssClasses = {
      input: 'search-input',
      autocompleteContainer: 'Address__autocomplete-container'
    };
    const styles = {
      root: { width: '100%' }
    }

    const AutocompleteItem = ({formattedSuggestion}) => (
      <div className="Address__suggestion-item">
        <LocationIcon color="#616161" className="Demo__suggestion-icon"/>
        <strong>{formattedSuggestion.mainText}</strong>{' '}
        <small className="text-muted">{formattedSuggestion.secondaryText}</small>
      </div>);
    const props = {...this.props};
    delete props.location;
    delete props.allowedZipCodes;
    delete props.forbiddenZipCodes;
    delete props.checkIsCorrectDeliveryAddress;

    const inputProps = {
      onBlur: () => {
      },
      onFocus: () => {
      },
      ...props,
      type: 'text',
      value: this.state.address,
      onChange: this.handleChange,
      // autoFocus: true,
      // placeholder: "Enter address",
      name: 'Demo__input',
      id: 'address-suggestion-input'
    };
    const lat = this.props.location && this.props.location.latitude ? this.props.location.latitude : 37.6853373;
    const lng = this.props.location && this.props.location.longitude ? this.props.location.longitude : -122.09284860000002;
    const radius = this.props.radius ? this.props.radius : 20000;
    const searchTerms = {
      location: new window.google.maps.LatLng(lat, lng),
      radius: Number(radius),
      strictbounds: true,
      types: ['address'],
      componentRestrictions: {
        country: 'us'
      }
    };

    return (
      <div className="page-wrapper">
        <div className="container" style={{position: 'relative'}}>
          <PlacesAutocomplete
            options={searchTerms}
            onSelect={this.handleSelect}
            autocompleteItem={AutocompleteItem}
            onEnterKeyDown={this.handleSelect}
            classNames={cssClasses}
            styles={styles}
            inputProps={inputProps}
            onError={this.onError}
          />
          {this.state.loading ? <div><i className="fa fa-spinner fa-pulse fa-3x fa-fw Demo__spinner"/></div> : null}
          {this.state.noPredictionsError ?
            <div className="predictions-error" style={props.predictionsErrorStyle}>{this.getErrorMessage()}</div> : null}
          {!this.state.loading && this.state.geocodeResults ?
            <div className="geocoding-results">{this.state.geocodeResults}</div> :
            null}
        </div>
      </div>
    );
  }
}

export default AddressAutocompleteContainer;



// WEBPACK FOOTER //
// ./src/components/AddressAutocompleteContainer/AddressAutocompleteContainer.js